import React from 'react';
import styled from 'styled-components';

interface Props {
  size?:
    | 'xxxsmall'
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'normal'
    | 'normedium'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge'
    | 'xxxlarge';
}

export const StyledSpacer = styled.div<Props>`
  height: ${(props) => (props.size ? props.theme.sizes[props.size] : '')};
`;

export const Spacer: React.FunctionComponent<Props> = (props) => <StyledSpacer {...props} />;
